import React from 'react';

const SvgNaviconRedbubble = (props) => {
  return (
    <svg viewBox="0 0 37.37 37.37" {...props}>
      <style>{`.navicon_redbubble_svg__st0{fill:#373737;stroke:none}`}</style>
      <path
        className="navicon_redbubble_svg__st0"
        d="M18.69 37.37C8.38 37.37 0 28.99 0 18.69S8.38 0 18.69 0c10.3 0 18.69 8.38 18.69 18.69s-8.39 18.68-18.69 18.68zm0-36.37C8.93 1 1 8.93 1 18.69c0 9.75 7.93 17.69 17.69 17.69s17.69-7.93 17.69-17.69C36.37 8.93 28.44 1 18.69 1z"
      />
      <path
        className="navicon_redbubble_svg__st0"
        d="M17.97 25.26H7.9c-.27 0-.48-.22-.48-.49V12.6c0-.27.21-.49.48-.49h4.7c2.94 0 4.69 1.59 4.69 4.23 0 1.76-.89 3.15-2.31 3.71l3.35 4.39c.27.32.05.81-.36.82zM25.09 25.26h-4.85a.49.49 0 01-.49-.49V12.6c0-.27.22-.49.49-.49h4.49c3.37 0 4.08 1.99 4.08 3.65 0 .96-.26 1.73-.77 2.29 1.24.51 1.91 1.66 1.91 3.33 0 2.43-1.82 3.88-4.86 3.88z"
      />
    </svg>
  );
};

export default SvgNaviconRedbubble;
